import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Home from "./components/Home";
import EmployeeDetail from "./components/EmployeeDetail";
import Login from "./components/Login";
import PasswordResetForm from "./components/PasswordResetForm";
import { AuthProvider, useAuth } from "./components/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-content">
          <h1 className="app-title" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            Overtime Calculator
          </h1>
          {user && (
            <div className="user-info">
              <span className="username">{user.username}</span>
              <button onClick={logout} className="logout-button">
                Abmelden
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

const AppContent = () => {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Lädt...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            authenticated ? <Navigate to="/" replace /> : <Login />
          } />
          <Route path="/password-reset/:token" element={<PasswordResetForm />} />
          <Route path="/" element={
            <ProtectedRoute>
              <AppHeader />
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/employee/:employeeName" element={
            <ProtectedRoute>
              <AppHeader />
              <EmployeeDetail />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;